import {useState} from 'react';
import PropTypes from 'prop-types';
import isNumber from 'lodash/isNumber';
// import {useNavigate} from 'react-router-dom';

// import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import CheckIcon from '@mui/icons-material/Check';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import Stack from '@mui/material/Stack';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Typography from "@mui/material/Typography";

import CustomNumberField from '../common/CustomNumberField';
import CustomSelect from '../common/CustomSelect';
import NoteEditor from '../common/NoteEditor';

import {formatCaseBillingType} from '../../helpers/cases';
import {formatPatientName} from '../../helpers/patients';
import {formatProviderName} from '../../helpers/providers';
import {formatDate} from '../../helpers/dates';
import {getClaimStatuses} from '../../helpers/selectOptions';
import {useUpdateClaimMutation} from '../../redux/services/claimApi';

const getColumns = ({onFieldChange, updating, hasSuccess, hasUpdateError}) => [
  {
    key: 'status',
    // renderCellContent: c => <EditCaseStatus case={c} />,
    renderCellContent: c => (
      <Stack direction='row' spacing={1}>
        {
          updating === 'status' && hasUpdateError &&
          <DoNotDisturbIcon color='error' />
        }
        {
          updating === 'status' && hasSuccess  &&
          <CheckIcon color='success' />
        }
        <CustomSelect
          defaultValue={c.status}
          options={getClaimStatuses()}
          style={{minWidth: '150px'}}
          onChange={onFieldChange('status')}
        />
      </Stack>
    ),
  },
  {
    key: 'patient',
    renderCellContent: c => formatPatientName(c.patient),
  },
  {
    key: 'date',
    align: 'center',
    renderCellContent: c => (
      <Typography variant='small500Inter'>
          {
          c?.session?.date 
          ? formatDate(c.session.date, 'M/D/YYYY')
          : '-'
        }
      </Typography>
    ),
  },
  {
    key: 'provider',
    renderCellContent: c => formatProviderName(c.provider),
  },
  {
    key: 'billing_category',
    renderCellContent: c => formatCaseBillingType(c?.case, {includePlanCategory: true}),
  },
  {
    key: 'amount_billed',
    align: 'center',
    renderCellContent: c => isNumber(c.amount_billed) ? '$' + c.amount_billed : '',
  },
  {
    key: 'amount_paid',
    align: 'center',
    renderCellContent: c => (
      <Stack direction='row' spacing={1}>
        {
          updating === 'amount_paid' && hasUpdateError &&
          <DoNotDisturbIcon color='error' />
        }
        {
          updating === 'amount_paid' && hasSuccess  &&
          <CheckIcon color='success' />
        }
        <CustomNumberField
          defaultValue={isNumber(c.amount_paid) ? c.amount_paid : ''}
          style={{width: '90px'}}
          onChange={onFieldChange('amount_paid')}
        />
      </Stack>
    ),
  },
  {
    key: 'provider_payout',
    align: 'center',
    renderCellContent: c => isNumber(c?.session?.provider_claim_payout) ? '$' + c.session.provider_claim_payout : '',
  },
  {
    key: 'payer',
    renderCellContent: c => c?.case?.payer_plan?.payer ? c?.case?.payer_plan?.payer.name : '-',
  },
  {
    key: 'facility',
    renderCellContent: c => c?.provider?.facility?.name,
  },
  // {
  //   key: 'eob',
  //   renderCellContent: c => 'TODO',
  // },
  {
    key: 'note',
    renderCellContent: c => (
      <NoteEditor 
        note={c.note} 
        onSubmit={onFieldChange('note')}
      />
    ),
  },
];

const handleFieldChange = ({id, put, setUpdating}) => field => async e => {
  setUpdating(field);
  const body = {[field]: e.target.value};
  const request = await put({id, body});
};

const ClaimTableRow = props => {
  // const navigate = useNavigate();
  const [updating, setUpdating] = useState(null);
  const {data: c} = props;
  const [put, request] = useUpdateClaimMutation();
  const onFieldChange = handleFieldChange({
    id: c.id, 
    put, 
    setUpdating,
  });
  const columns = getColumns({
    onFieldChange, 
    updating, 
    hasUpdateError: !!request?.error,
    hasSuccess: request?.isSuccess,
  })
  .filter(col => props?.columns ? props?.columns.includes(col.key) : true);
  return (
    <TableRow
      key={c.id}
    >
      {columns.map((col, i) => (
        <TableCell 
          key={i} 
          align={col.align || 'left'} 
        >
          {col.renderCellContent(c, {request})}
        </TableCell>
      ))}
    </TableRow>
  );
};

ClaimTableRow.propTypes = {
  data: PropTypes.object,
  // buttons: PropTypes.arrayOf(PropTypes.element),
  // isPatient: PropTypes.bool,
  // afterSave: PropTypes.func,
};

export default ClaimTableRow;
